import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class IndexRoute extends Route {
  @service router;
  @service session;
  @service currentUser;
  beforeModel() {
    this.router.transitionTo('login');
  }

  model() {
    return {};
  }
}

export default instrumentRoutePerformance(IndexRoute);
